(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["builderfy-bento"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyBento extends HTMLElement {
    connectedCallback() {
      this.strom = this.querySelector('.bfy-strom');
      if (!this.strom) return;
      this._tick = () => {
        const r = this.getBoundingClientRect(), vh = window.innerHeight || 1;
        const p = Math.min(1, Math.max(0, (vh * 0.5 - r.top) / (r.height || 1)));
        this.strom.style.setProperty('--p', p.toFixed(4)); this._raf = 0;
      };
      this._onScroll = () => { if (!this._raf) this._raf = requestAnimationFrame(this._tick); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._tick();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }
  }
  if (!customElements.get('builderfy-bento')) customElements.define('builderfy-bento', BuilderfyBento);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-container-scroll"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyContainerScroll extends HTMLElement {
    connectedCallback() {
      this.card = this;
      this._tick = () => {
        const r = this.getBoundingClientRect(), vh = window.innerHeight || 1;
        const denom = (r.height - vh) || 1;
        const prog = Math.min(1, Math.max(0, -r.top / denom));
        this.style.setProperty('--prog', prog.toFixed(4));
        const strom = this.querySelector('.bfy-strom');
        if (strom) {
          const p = Math.min(1, Math.max(0, (vh * 0.5 - r.top) / (r.height || 1)));
          strom.style.setProperty('--p', p.toFixed(4));
        }
        this._raf = 0;
      };
      this._onScroll = () => { if (!this._raf) this._raf = requestAnimationFrame(this._tick); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._tick();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }
  }
  if (!customElements.get('builderfy-container-scroll')) customElements.define('builderfy-container-scroll', BuilderfyContainerScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-dashboards"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyDashboards extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          const last = this.tabs.length - 1;
          let next = null;
          if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
          else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        });
      });
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
  }
  if (!customElements.get('builderfy-dashboards')) {
    customElements.define('builderfy-dashboards', BuilderfyDashboards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-einehand"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyEineHand extends HTMLElement {
    connectedCallback() {
      this.flow = this.querySelector('.bfy-eh__flow');
      this.svg = this.querySelector('.bfy-eh__beams');
      this.source = this.querySelector('[data-eh-source]');
      this.targets = Array.from(this.querySelectorAll('[data-eh-target]'));

      this.zeichne();
      if ('ResizeObserver' in window && this.flow) {
        this._ro = new ResizeObserver(() => this.zeichne());
        this._ro.observe(this.flow);
      } else {
        this._onR = () => this.zeichne();
        window.addEventListener('resize', this._onR);
      }

      // Einblenden beim Sichtbarwerden
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { this.classList.add('is-in'); return; }
      if (!('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }
      this._io = new IntersectionObserver((es, o) => {
        es.forEach((e) => { if (e.isIntersecting) { this.classList.add('is-in'); o.disconnect(); } });
      }, { threshold: .15 });
      this._io.observe(this);
    }

    zeichne() {
      if (!this.flow || !this.svg || !this.source || !this.targets.length) return;
      const f = this.flow.getBoundingClientRect();
      if (f.width < 2) return;
      this.svg.setAttribute('viewBox', `0 0 ${f.width} ${f.height}`);
      const s = this.source.getBoundingClientRect();
      const sx = s.right - f.left;
      const sy = s.top - f.top + s.height / 2;
      let d = '';
      this.targets.forEach((t) => {
        const r = t.getBoundingClientRect();
        const tx = r.left - f.left;
        const ty = r.top - f.top + r.height / 2;
        const mx = sx + (tx - sx) * 0.5;
        d += `M ${sx} ${sy} C ${mx} ${sy}, ${mx} ${ty}, ${tx} ${ty} `;
      });
      this.svg.innerHTML = `<path class="bfy-eh__base" d="${d}"/><path class="bfy-eh__pulse" d="${d}"/>`;
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      if (this._onR) window.removeEventListener('resize', this._onR);
      if (this._io) this._io.disconnect();
    }
  }
  if (!customElements.get('builderfy-einehand')) {
    customElements.define('builderfy-einehand', BuilderfyEineHand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-haken"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyHaken extends HTMLElement {
    connectedCallback() {
      this.strom = this.querySelector('.bfy-strom');
      if (!this.strom) return;
      this._tick = () => {
        const r = this.getBoundingClientRect(), vh = window.innerHeight || 1;
        const p = Math.min(1, Math.max(0, (vh * 0.5 - r.top) / (r.height || 1)));
        this.strom.style.setProperty('--p', p.toFixed(4)); this._raf = 0;
      };
      this._onScroll = () => { if (!this._raf) this._raf = requestAnimationFrame(this._tick); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._tick();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this._onScroll); window.removeEventListener('resize', this._onScroll); }
  }
  if (!customElements.get('builderfy-haken')) customElements.define('builderfy-haken', BuilderfyHaken);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-hero-3d"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyHero3d extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.bfy-3d__stage');
      if (!this.stage) return;

      this.messeKopf();
      if (this.dataset.merge === 'true' && 'ResizeObserver' in window) {
        const kopf = document.querySelector('.bfy-hd');
        if (kopf) {
          this._kopfBeobachter = new ResizeObserver(() => this.messeKopf());
          this._kopfBeobachter.observe(kopf);
        }
      }

      // Im Theme-Editor sofort laden, dort wird nicht wie ueblich gescrollt
      if (this.dataset.editor === 'true' && this.dataset.enabled === 'true') {
        this.load();
        return;
      }

      if (this.dataset.enabled !== 'true' || !this.shouldLoad()) {
        this.stage.classList.add('is-ready', 'is-standbild');
        const ph = this.stage.querySelector('.bfy-3d__ph span');
        if (ph) ph.remove();
        return;
      }

      // Erst laden, wenn die Karte in Sichtweite kommt. Rund 3,3 MB duerfen
      // den ersten Bildaufbau nicht blockieren.
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this._observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.disconnect();
          this.load();
        });
      }, { rootMargin: '200px' });
      this._observer.observe(this);
    }

    // Die Karte reicht genau so weit nach oben, wie die Kopfleiste hoch ist
    messeKopf() {
      if (this.dataset.merge !== 'true') return;
      const kopf = document.querySelector('.bfy-hd');
      if (!kopf) return;
      this.style.setProperty('--bfy-3d-head', Math.round(kopf.getBoundingClientRect().height) + 'px');
    }

    shouldLoad() {
      const c = navigator.connection;
      // Bei ausdruecklichem Datensparen oder 2G bleibt es beim Standbild.
      if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return false;
      // "Bewegung reduzieren" hat die Szene frueher komplett unterdrueckt. Das
      // ist zu grob: die Einstellung zielt auf ruckende Effekte, nicht auf eine
      // ruhige Szene, und sie ist auf vielen Rechnern dauerhaft an. Wer sie
      // trotzdem beachten will, schaltet es in der Section ein.
      if (this.dataset.ruhig === 'true'
          && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
      return true;
    }

    load() {
      const start = () => {
        const viewer = document.createElement('spline-viewer');
        viewer.setAttribute('url', this.dataset.scene);
        const laeuft = () => {
          if (this._frist) { clearTimeout(this._frist); this._frist = null; }
          this.stage.classList.remove('is-standbild');
          this.stage.classList.add('is-ready', 'is-live');
          this.entferneAbzeichen(viewer);
        };
        viewer.addEventListener('load', laeuft, { once: true });

        // Der Viewer meldet sein load-Ereignis nicht zuverlaessig. Verlaesslich
        // ist der Zeitpunkt, an dem er seinen Canvas sichtbar schaltet: genau
        // dann steht die Szene, und erst dann darf das Standbild weichen.
        let runden = 0;
        const wacht = setInterval(() => {
          const leinwand = viewer.shadowRoot && viewer.shadowRoot.querySelector('canvas');
          if (leinwand && getComputedStyle(leinwand).visibility !== 'hidden') {
            clearInterval(wacht);
            laeuft();
          } else if (++runden > 80) {
            clearInterval(wacht);
            if (!this.stage.classList.contains('is-live')) {
              this.stage.classList.add('is-ready', 'is-standbild');
            }
          }
        }, 250);
        this._wacht = wacht;
        this.stage.appendChild(viewer);
        this.entferneAbzeichen(viewer);
        // Auch ohne load-Ereignis nicht ewig den Platzhalter zeigen
        // Nach dieser Frist ist der Ladekreis unglaubwuerdig, dann lieber das
        // Standbild. Laeuft die Szene da schon, hat die Frist nichts zu melden.
        this._frist = setTimeout(() => {
          if (this.stage.classList.contains('is-live')) return;
          this.stage.classList.add('is-ready', 'is-standbild');
        }, 8000);
      };

      if (customElements.get('spline-viewer')) { start(); return; }

      // Der Viewer kommt von einem fremden Server. Faellt der aus oder wird er
      // gefiltert, bleibt es beim Standbild, statt bei einer leeren Flaeche.
      const quellen = [this.dataset.viewer, this.dataset.viewerAlt].filter(Boolean);
      const versuche = (i) => {
        if (i >= quellen.length) { this.stage.classList.add('is-ready', 'is-standbild'); return; }
        const script = document.createElement('script');
        let erledigt = false;
        const weiter = () => { if (!erledigt) { erledigt = true; versuche(i + 1); } };
        script.type = 'module';
        script.src = quellen[i];
        script.onload = () => { if (!erledigt) { erledigt = true; start(); } };
        script.onerror = weiter;
        // Ein haengender Abruf darf nicht dazu fuehren, dass nie etwas passiert
        setTimeout(weiter, 12000);
        document.head.appendChild(script);
      };
      versuche(0);
    }

    // Das Abzeichen liegt im Shadow DOM und ist per CSS von aussen nicht
    // erreichbar. Es wird zudem erst nach dem Aufbau eingehaengt, deshalb
    // beobachten wir den Baum, bis es auftaucht.
    entferneAbzeichen(viewer) {
      if (this.dataset.hideBadge !== 'true') return;
      const wurzel = viewer.shadowRoot;
      if (!wurzel) return;
      const weg = () => {
        const treffer = wurzel.querySelectorAll('#logo, a[href*="spline.design"]');
        treffer.forEach((el) => el.remove());
        return treffer.length > 0;
      };
      if (weg()) return;
      const beobachter = new MutationObserver(() => { if (weg()) beobachter.disconnect(); });
      beobachter.observe(wurzel, { childList: true, subtree: true });
      setTimeout(() => beobachter.disconnect(), 20000);
    }

    disconnectedCallback() {
      if (this._wacht) clearInterval(this._wacht);
      if (this._frist) clearTimeout(this._frist);
      if (this._observer) this._observer.disconnect();
      if (this._kopfBeobachter) this._kopfBeobachter.disconnect();
    }
  }
  class BuilderfyDia extends HTMLElement {
    connectedCallback() {
      this.span = this.querySelector('.bfy-dia');
      const data = this.querySelector('.bfy-dia__data');
      if (!this.span || !data) return;
      try { this.words = JSON.parse(data.textContent).map((w) => w.trim()).filter(Boolean); }
      catch (e) { return; }
      // Nur freischalten, wenn der Browser eigene Eigenschaften animieren kann
      const kannBand = typeof CSS !== 'undefined' && typeof CSS.registerProperty === 'function';
      if (kannBand) this.span.classList.add('is-live');

      if (this.words.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.sizer = this.querySelector('.bfy-dia__sizer');
      this.breiteFestlegen();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.breiteFestlegen());
      }

      if ('ResizeObserver' in window && this.parentElement) {
        this._beobachter = new ResizeObserver(() => this.breiteFestlegen());
        this._beobachter.observe(this.parentElement);
      }

      this.index = 0;
      this.laeuft = false;
      const ms = (parseFloat(this.dataset.interval) || 3) * 1000;
      this.timer = setInterval(() => this.next(), ms);
    }

    // Der Halter bekommt das breiteste Wort, damit die Zeile ihre Breite
    // behaelt und beim Wechsel nichts nachrueckt.
    breiteFestlegen() {
      if (!this.sizer) return;
      this.style.setProperty('--dia-fit', '1');
      let breitestes = this.words[0];
      let breite = 0;
      this.words.forEach((w) => {
        this.sizer.textContent = w;
        const b = this.sizer.getBoundingClientRect().width;
        if (b > breite) { breite = b; breitestes = w; }
      });
      this.sizer.textContent = breitestes;

      const platz = this.parentElement ? this.parentElement.getBoundingClientRect().width : 0;
      if (platz > 0 && breite > platz) {
        this.style.setProperty('--dia-fit', (platz / breite).toFixed(3));
      }
    }

    next() {
      if (this.laeuft) return;
      this.laeuft = true;
      this.index = (this.index + 1) % this.words.length;
      const word = this.words[this.index];
      this.span.classList.add('is-swapping');
      setTimeout(() => {
        this.span.textContent = word;
        this.span.classList.remove('is-swapping');
        // Animation neu starten, damit das Band erneut laeuft
        this.span.style.animation = 'none';
        void this.span.offsetWidth;
        this.span.style.animation = '';
        this.laeuft = false;
      }, 240);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      if (this._beobachter) this._beobachter.disconnect();
    }
  }
  if (!customElements.get('builderfy-dia')) {
    customElements.define('builderfy-dia', BuilderfyDia);
  }

  if (!customElements.get('builderfy-hero-3d')) {
    customElements.define('builderfy-hero-3d', BuilderfyHero3d);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-hero"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyHero extends HTMLElement {
    connectedCallback() {
      this._observer = null;
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));

      this.querySelectorAll('.bfy-draw path').forEach((p) => {
        try { p.style.setProperty('--len', Math.ceil(p.getTotalLength())); } catch (e) { /* getTotalLength kann in hidden SVGs werfen */ }
      });

      const targets = this.querySelectorAll('.bfy-inview, .bfy-draw');
      if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }
      this._observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });

      targets.forEach((el, i) => {
        if (el.classList.contains('bfy-inview')) el.style.transitionDelay = (i * 90) + 'ms';
        this._observer.observe(el);
      });
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }
  }

  if (!customElements.get('builderfy-hero')) {
    customElements.define('builderfy-hero', BuilderfyHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-integrations"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyIntegrations extends HTMLElement {
    connectedCallback() {
      const targets = this.querySelectorAll('.bfy-in');
      if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }
      this._observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
      targets.forEach((el) => this._observer.observe(el));
    }
    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }
  }
  if (!customElements.get('builderfy-integrations')) {
    customElements.define('builderfy-integrations', BuilderfyIntegrations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-prozess"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyProzess extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.bfy-pc__slide'));
      this.tabs = Array.from(this.querySelectorAll('.bfy-pc__tab'));
      this.details = Array.from(this.querySelectorAll('.bfy-pc__detail'));
      this.n = this.tabs.length;
      if (this.n < 2) return;

      this.duration = (parseFloat(this.dataset.duration) || 5) * 1000;
      this.fastDuration = 400;
      this.active = 0;
      this.progress = 0;
      this.isFast = false;
      this.target = null;
      this.reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.tabs.forEach((t) => t.addEventListener('click', () => this.klick(parseInt(t.dataset.index, 10))));
      const prev = this.querySelector('.bfy-pc__arrow--prev');
      const next = this.querySelector('.bfy-pc__arrow--next');
      if (prev) prev.addEventListener('click', () => this.klick((this.active - 1 + this.n) % this.n));
      if (next) next.addEventListener('click', () => this.klick((this.active + 1) % this.n));

      if (this.reduziert) return;
      if (!('IntersectionObserver' in window)) { this.starte(); return; }
      this._obs = new IntersectionObserver((es) => {
        es.forEach((e) => { if (e.isIntersecting) this.starte(); else this.stoppe(); });
      }, { threshold: .3 });
      this._obs.observe(this);
    }

    starte() {
      if (this._laeuft || this.reduziert) return;
      this._laeuft = true;
      this.firstFrame = performance.now();
      this._raf = requestAnimationFrame((t) => this.animate(t));
    }
    stoppe() { this._laeuft = false; if (this._raf) cancelAnimationFrame(this._raf); }

    // Ablauf 1:1 wie im 21st.dev-Baustein (ProgressSlider)
    animate(now) {
      if (!this._laeuft) return;
      const dur = this.isFast ? this.fastDuration : this.duration;
      const frac = (now - this.firstFrame) / dur;
      if (frac <= 1) {
        this.progress = this.isFast ? this.progress + (100 - this.progress) * frac : frac * 100;
        this.renderProg();
        this._raf = requestAnimationFrame((t) => this.animate(t));
      } else {
        if (this.isFast) { this.isFast = false; if (this.target !== null) { this.setActive(this.target); this.target = null; } }
        else { this.setActive((this.active + 1) % this.n); }
        this.progress = 0; this.firstFrame = now;
        this._raf = requestAnimationFrame((t) => this.animate(t));
      }
    }

    renderProg() {
      const bar = this.tabs[this.active] && this.tabs[this.active].querySelector('.bfy-pc__prog');
      if (bar) bar.style.transform = 'scaleX(' + (this.progress / 100) + ')';
    }

    setActive(i) {
      this.active = i;
      this.slides.forEach((sl, k) => sl.classList.toggle('is-active', k === i));
      this.details.forEach((d, k) => d.classList.toggle('is-active', k === i));
      this.tabs.forEach((t, k) => {
        const a = k === i;
        t.classList.toggle('is-active', a);
        t.setAttribute('aria-selected', a ? 'true' : 'false');
        const bar = t.querySelector('.bfy-pc__prog');
        if (bar) bar.style.transform = 'scaleX(0)';
      });
    }

    klick(i) {
      if (i === this.active) return;
      if (this.reduziert) { this.setActive(i); return; }
      this.target = i; this.isFast = true; this.firstFrame = performance.now();
      if (!this._laeuft) this.starte();
    }

    disconnectedCallback() { this.stoppe(); if (this._obs) this._obs.disconnect(); }
  }
  if (!customElements.get('builderfy-prozess')) {
    customElements.define('builderfy-prozess', BuilderfyProzess);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-ratgeber"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyRatgeber extends HTMLElement {
    connectedCallback() {
      const links = Array.from(this.querySelectorAll('.bfy-toc__link'));
      if (!links.length || !('IntersectionObserver' in window)) return;
      const setzeAktiv = (id) => links.forEach((l) => l.classList.toggle('is-current', l.dataset.target === id));
      const ziele = links.map((l) => this.querySelector('#' + l.dataset.target)).filter(Boolean);
      this._spy = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) setzeAktiv(e.target.id); });
      }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
      ziele.forEach((z) => this._spy.observe(z));
    }
    disconnectedCallback() { if (this._spy) this._spy.disconnect(); }
  }
  if (!customElements.get('builderfy-ratgeber')) {
    customElements.define('builderfy-ratgeber', BuilderfyRatgeber);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-rechtstext"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyRechtstext extends HTMLElement {
    connectedCallback() {
      const tiles = this.querySelectorAll('.bfy-rt__tile');
      if (!('IntersectionObserver' in window)) {
        tiles.forEach((tile) => tile.classList.add('is-in'));
        return;
      }
      this._observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
      tiles.forEach((tile) => this._observer.observe(tile));
    }
    disconnectedCallback() { if (this._observer) this._observer.disconnect(); }
  }
  if (!customElements.get('builderfy-rechtstext')) {
    customElements.define('builderfy-rechtstext', BuilderfyRechtstext);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-seitenarten"] && !Shopify.designMode) return;
  try {
    
  class BuilderfySeitenarten extends HTMLElement {
    connectedCallback() {
      this.buehne = this.querySelector('.bfy-arten__buehne');
      if (!this.buehne) return;
      this.karten = Array.from(this.querySelectorAll('.bfy-arten__karte'));
      if (!this.karten.length) return;

      if (!this.stapelMoeglich()) { this.oeffnen(); return; }

      this.stapelnAufbauen();

      // Im Editor gibt es kein normales Scrollen, deshalb direkt zeigen
      if (this.dataset.editor === 'true') {
        setTimeout(() => this.oeffnen(), 500);
        return;
      }

      if (!('IntersectionObserver' in window)) { this.oeffnen(); return; }
      this._beobachter = new IntersectionObserver((eintraege, obs) => {
        eintraege.forEach((e) => {
          if (!e.isIntersecting) return;
          obs.disconnect();
          this._beobachter = null;
          this.oeffnen();
        });
        // Ausloesen, sobald die Oberkante der Buehne die untere
        // Bildschirmhaelfte erreicht. Ein Schwellwert in Prozent waere von
        // der Hoehe der Buehne abhaengig und wird bei zwei Reihen Geraeten
        // auf kleinen Bildschirmen nicht mehr zuverlaessig erreicht.
      }, { threshold: 0, rootMargin: '0px 0px -18% 0px' });
      this._beobachter.observe(this.buehne);

      // Solange noch nicht aufgefaechert wurde, muss der Stapel bei
      // geaenderter Breite neu gerechnet werden
      this._aufNeueBreite = () => {
        if (this.classList.contains('is-open')) return;
        if (!this.stapelMoeglich()) { this.oeffnen(); return; }
        this.stapelnAufbauen();
      };
      window.addEventListener('resize', this._aufNeueBreite);
    }

    stapelMoeglich() {
      if (this.dataset.stapel !== 'true') return false;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
      // Erst ab drei nebeneinander ergibt "Mitte bleibt, Aussen geht raus"
      // ueberhaupt Sinn. Darunter blenden die Karten schlicht ein.
      return window.innerWidth >= 1080;
    }

    // Anker ist die mittlere Karte. Sie bleibt stehen, die uebrigen legen
    // sich hinter sie und gleiten beim Oeffnen nach aussen. Es wird nur ein
    // transform je Karte gesetzt, das Layout bleibt unberuehrt.
    stapelnAufbauen() {
      this.classList.add('is-messend');
      this.classList.remove('is-stacked');

      const ankerIndex = Math.floor(this.karten.length / 2);
      const anker = this.karten[ankerIndex].getBoundingClientRect();
      const ziel = { x: anker.left + anker.width / 2, y: anker.top + anker.height / 2 };
      const streuung = (parseFloat(this.dataset.streuung) || 100) / 100;

      this.karten.forEach((karte, i) => {
        const k = karte.getBoundingClientRect();
        const dx = ziel.x - (k.left + k.width / 2);
        const dy = ziel.y - (k.top + k.height / 2);
        karte.style.setProperty('--dx', Math.round(dx * streuung) + 'px');
        karte.style.setProperty('--dy', Math.round(dy * streuung) + 'px');
        // Abstand zum Anker steuert die kleine Staffelung beim Oeffnen
        karte.style.setProperty('--i', String(Math.abs(i - ankerIndex)));
        karte.classList.toggle('is-anchor', i === ankerIndex);
        // Anker oben, damit die aeusseren wirklich dahinter verschwinden
        karte.style.zIndex = i === ankerIndex ? '5' : '1';
      });

      this.classList.add('is-stacked');
      void this.offsetWidth;
      this.classList.remove('is-messend');
    }

    oeffnen() {
      this.classList.remove('is-stacked', 'is-messend');
      this.classList.add('is-open');
      this.karten.forEach((k) => {
        k.style.removeProperty('--dx');
        k.style.removeProperty('--dy');
      });
      // Nach dem Auffaechern kostet will-change nur noch Speicher
      setTimeout(() => {
        this.karten.forEach((k) => { k.style.willChange = 'auto'; });
      }, 1600);
    }

    disconnectedCallback() {
      if (this._beobachter) this._beobachter.disconnect();
      if (this._aufNeueBreite) window.removeEventListener('resize', this._aufNeueBreite);
    }
  }
  if (!customElements.get('builderfy-seitenarten')) {
    customElements.define('builderfy-seitenarten', BuilderfySeitenarten);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-substanz"] && !Shopify.designMode) return;
  try {
    
  class BuilderfySubstanz extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.bfy-ss__item'));
      this.panels = Array.from(this.querySelectorAll('.bfy-ss__panel'));
      this.dots = Array.from(this.querySelectorAll('.bfy-ss__dot'));
      this.strom = this.querySelector('.bfy-strom');

      if (this.items.length && 'IntersectionObserver' in window) {
        const setActive = (i) => {
          this.items.forEach((el, k) => el.classList.toggle('is-active', k === i));
          this.panels.forEach((el, k) => el.classList.toggle('is-active', k === i));
          this.dots.forEach((el, k) => el.classList.toggle('is-active', k === i));
        };
        this._obs = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) setActive(parseInt(e.target.dataset.i, 10)); });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        this.items.forEach((el) => this._obs.observe(el));
      }

      if (this.strom) {
        this._tick = () => {
          const r = this.getBoundingClientRect(), vh = window.innerHeight || 1;
          const p = Math.min(1, Math.max(0, (vh * 0.5 - r.top) / (r.height || 1)));
          this.strom.style.setProperty('--p', p.toFixed(4)); this._raf = 0;
        };
        this._onScroll = () => { if (!this._raf) this._raf = requestAnimationFrame(this._tick); };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        this._tick();
      }
    }
    disconnectedCallback() {
      if (this._obs) this._obs.disconnect();
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }
  }
  if (!customElements.get('builderfy-substanz')) customElements.define('builderfy-substanz', BuilderfySubstanz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-teaser-ads"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyTeaserAds extends HTMLElement {
    connectedCallback(){
      if ('IntersectionObserver' in window){
        const o = new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){this.classList.add('is-in');o.disconnect();}})},{rootMargin:'-12% 0px -12% 0px'});
        o.observe(this);
      } else { this.classList.add('is-in'); }
    }
  }
  if (!customElements.get('builderfy-teaser-ads')) customElements.define('builderfy-teaser-ads', BuilderfyTeaserAds);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-vertragstext"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyVertragstext extends HTMLElement {
    connectedCallback() {
      const items = this.querySelectorAll('.bfy-clause');
      if (!('IntersectionObserver' in window)) {
        items.forEach((el) => el.classList.add('is-in'));
        return;
      }
      this._observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
      items.forEach((el) => this._observer.observe(el));

      // Der oberste sichtbare Paragraf wird im Verzeichnis markiert
      const links = Array.from(this.querySelectorAll('.bfy-toc__link'));
      if (!links.length) return;
      const byId = new Map(links.map((a) => [a.dataset.target, a]));
      const visible = new Set();
      this._spy = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.add(entry.target.id);
          else visible.delete(entry.target.id);
        });
        let current = null;
        items.forEach((el) => { if (!current && visible.has(el.id)) current = el.id; });
        links.forEach((a) => a.classList.remove('is-current'));
        if (current && byId.has(current)) {
          const active = byId.get(current);
          active.classList.add('is-current');
          const box = active.closest('.bfy-toc');
          if (box && box.scrollHeight > box.clientHeight) {
            const top = active.offsetTop - box.clientHeight / 2;
            box.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          }
        }
      }, { rootMargin: '-20% 0px -65% 0px' });
      items.forEach((el) => this._spy.observe(el));
    }
    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._spy) this._spy.disconnect();
    }
  }
  if (!customElements.get('builderfy-vertragstext')) {
    customElements.define('builderfy-vertragstext', BuilderfyVertragstext);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-vorgehen"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyVorgehen extends HTMLElement {
    connectedCallback() {
      // Die Klasse bfy-vg sitzt auf diesem Element selbst
      if (!('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }
      this._obs = new IntersectionObserver((eintraege, obs) => {
        eintraege.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-in');
          obs.disconnect();
        });
      }, { threshold: .2 });
      this._obs.observe(this);
    }
    disconnectedCallback() { if (this._obs) this._obs.disconnect(); }
  }
  if (!customElements.get('builderfy-vorgehen')) {
    customElements.define('builderfy-vorgehen', BuilderfyVorgehen);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-vorteile"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyVorteile extends HTMLElement {
    connectedCallback() {
      const tiles = this.querySelectorAll('.bfy-tile');
      if (!('IntersectionObserver' in window)) {
        tiles.forEach((t) => t.classList.add('is-in'));
        return;
      }
      this._observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
      tiles.forEach((t) => this._observer.observe(t));
    }
    disconnectedCallback() { if (this._observer) this._observer.disconnect(); }
  }
  if (!customElements.get('builderfy-vorteile')) {
    customElements.define('builderfy-vorteile', BuilderfyVorteile);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-werbung"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyWerbung extends HTMLElement {
    connectedCallback() {
      this.num = this.querySelector('.bfy-ad__num');
      this.ziel = parseFloat(this.dataset.value) || 0;
      this.dauer = (parseFloat(this.dataset.duration) || 2) * 1000;
      if (!this.num) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.num.textContent = this.formatiere(this.ziel);
        return;
      }
      if (!('IntersectionObserver' in window)) { this.zaehle(); return; }
      this._obs = new IntersectionObserver((eintraege, obs) => {
        eintraege.forEach((e) => { if (e.isIntersecting) { obs.disconnect(); this.zaehle(); } });
      }, { threshold: .4 });
      this._obs.observe(this);
    }

    formatiere(n) {
      return new Intl.NumberFormat('de-DE').format(Math.round(n));
    }

    // Hochzaehlen mit weichem Auslauf, wie der Spring im Original
    zaehle() {
      const start = performance.now();
      const lauf = (jetzt) => {
        const t = Math.min(1, (jetzt - start) / this.dauer);
        const e = 1 - Math.pow(1 - t, 3);
        this.num.textContent = this.formatiere(this.ziel * e);
        if (t < 1) requestAnimationFrame(lauf);
        else this.num.textContent = this.formatiere(this.ziel);
      };
      requestAnimationFrame(lauf);
    }

    disconnectedCallback() { if (this._obs) this._obs.disconnect(); }
  }
  if (!customElements.get('builderfy-werbung')) {
    customElements.define('builderfy-werbung', BuilderfyWerbung);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builderfy-zahlen"] && !Shopify.designMode) return;
  try {
    
  class BuilderfyZahlen extends HTMLElement {
    connectedCallback(){
      this.nums = Array.from(this.querySelectorAll('.bfy-zn__num'));
      const fmt = (n) => n.toLocaleString('de-DE');
      const run = (el) => {
        const raw = (el.dataset.target || '').replace(/\./g, '').replace(/\s/g, '');
        const target = parseInt(raw, 10);
        if (isNaN(target)) return; // nicht-numerisch bleibt statisch
        const dur = 1500, t0 = performance.now();
        el.textContent = '0';
        const step = (t) => {
          const p = Math.min(1, (t - t0) / dur);
          const eased = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(Math.round(target * eased));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      if ('IntersectionObserver' in window){
        const o = new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){run(e.target);o.unobserve(e.target);}})},{rootMargin:'-10% 0px -10% 0px'});
        this.nums.forEach(n => o.observe(n));
      }
    }
  }
  if (!customElements.get('builderfy-zahlen')) customElements.define('builderfy-zahlen', BuilderfyZahlen);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
